import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

let lang = localStorage.getItem('lang');

const messages = {
	'zh': require('@/assets/languages/zh.json'), // 中文繁体
	'vi': require('@/assets/languages/vi.json'), // 越南语
	'es': require('@/assets/languages/es.json'), // 西班牙
	'zh-cn': require('@/assets/languages/zhCn.json'), // 中文语言包
	'en': require('@/assets/languages/en.json'), // 英文语言包
	'pt': require('@/assets/languages/pt.json'), // 葡萄牙
	'fr': require('@/assets/languages/fr.json'), // 法语
	'de': require('@/assets/languages/de.json'), // 德语
	'it': require('@/assets/languages/it.json'), // 意大利语
	'ru': require('@/assets/languages/ru.json'), // 俄语
	'ar': require('@/assets/languages/ar.json'), // 阿拉伯语
	'pl': require('@/assets/languages/pl.json'), // 波兰语
	'nl': require('@/assets/languages/nl.json'), // 荷兰语
	'sv': require('@/assets/languages/sv.json'), // 瑞典语言
	'el': require('@/assets/languages/el.json'), // 希腊语
	'tr': require('@/assets/languages/tr.json'), // 土耳其语
};

const i18n = new VueI18n({
	globalInjection: true,
	locale: lang,
	messages,
});

export default i18n;